export default __webpack_public_path__ + "static/icon-hourglass-box-8623dbc2c94b109d5af21669b1a779bb.svg";